<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.loyaltyPointRecalculate.title')"
    :info="$t('components.customer.actions.loyaltyPointRecalculate.info', { name: customer.displayName })"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.customer.actions.loyaltyPointRecalculate.recalculate'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="py-4 text-left">
      <o-alert show variant="warning" class="text-sm" :title="$t('components.customer.actions.loyaltyPointRecalculate.warning')">
        <p>{{ $t('components.customer.actions.loyaltyPointRecalculate.recalculateBalance') }}</p>
        <p>{{ $t('components.customer.actions.loyaltyPointRecalculate.transactionsNotAffected') }}</p>
      </o-alert>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { OAlert } from '@/components/elements'

import type { Customer } from '~/_api/models/customer'

interface Props {
  customer: Customer
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref<any>()

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  try {
    const response = await $api.customer.recalculateLoyaltyPointBalance(props.customer.idCustomer.toString())

    if (response.success) {
      emit('success')

      $bus.emit.updated('Customer', response.data)

      $notification.toast({
        title: $i18n.t('components.customer.actions.loyaltyPointRecalculate.success'),
        variant: 'success',
      })

      return response
    }
  } catch (e) {
    console.log(e)
  }
}

defineExpose({ open })
</script>
